import { makeStyles, Box, Divider } from '@material-ui/core';
import React, { FC, ReactNode, useState } from 'react';
import EditBg from 'src/components/editor/EditBg';
import EditBgColor from 'src/components/editor/EditBgColor';
import EditBgImage from 'src/components/editor/EditBgImage';
import EditColor from 'src/components/editor/EditColor';
import EditDeeplink from 'src/components/editor/EditDeeplink';
import EditFont from 'src/components/editor/EditFont';
import EditFontFamily from 'src/components/editor/EditFontFamily';
import EditLayout from 'src/components/editor/EditLayout';
import EditRadius from 'src/components/editor/EditRadius';
import EditText from 'src/components/editor/EditText';
import EditTextAlign from 'src/components/editor/EditTextAlign';
import { useSelector, RootState } from 'src/store';
// import Contents from 'src/components/editor/Contents';

const useStyles = makeStyles(() => ({
  textFont: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },
  buttonBgColor: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem'
  }
}));

const Contents: FC<any> = ({ datas }) => {
  const classes = useStyles();
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );

  return (
    <Box>
      {datas?.bg?.map((type: any, idx: number) => {
        return (
          type && (
            <>
              <EditLayout key={idx} type={type}>
                <EditBg type={type} />
                {datas?.bgRadius?.[idx] && (
                  <>
                    <Box className={classes.buttonBgColor}>
                      {type.replaceAll('_', ' ').toUpperCase() + ' RADIUS'}
                    </Box>
                    <EditRadius type={type} max={datas?.bgRadiusMax?.[idx]} />
                  </>
                )}
                {datas?.bgDeeplink?.[idx] && (
                  <>
                    <Box className={classes.buttonBgColor}>DEEPLINK</Box>
                    <EditDeeplink type={type} />
                  </>
                )}
              </EditLayout>
              <Divider />
            </>
          )
        );
      })}
      {datas?.bgImage?.map((type: any, idx: number) => {
        return (
          type &&
          !(type === 'back' && currentIndex === 0) && (
            <>
              <EditLayout key={idx} type={type + ' IMAGE'}>
                <EditBgImage type={type} />
                {datas?.bgImageRadius?.[idx] && (
                  <>
                    <Box className={classes.buttonBgColor}>IMAGE RADIUS</Box>
                    <EditRadius
                      type={type}
                      max={datas?.bgImageRadiusMax?.[idx]}
                    />
                  </>
                )}
                {datas?.bgImageDeeplink?.[idx] && (
                  <>
                    <Box className={classes.buttonBgColor}>DEEPLINK</Box>
                    <EditDeeplink type={type} />
                  </>
                )}
              </EditLayout>
              <Divider />
            </>
          )
        );
      })}
      {datas?.bgColor?.map((type: any, idx: number) => {
        return (
          type &&
          !(type === 'back' && currentIndex === 0) && (
            <>
              <EditLayout key={idx} type={type + ' COLOR'}>
                <EditBgColor type={type} />
                {datas?.bgImageDeeplink?.[idx] && (
                  <>
                    <Box className={classes.buttonBgColor}>DEEPLINK</Box>
                    <EditDeeplink type={type} />
                  </>
                )}
              </EditLayout>
              <Divider />
            </>
          )
        );
      })}
      {datas?.textType?.map((type: any, idx: number) => {
        return (
          <div key={idx}>
            <EditLayout type={type}>
              {(datas?.fontFamily?.[idx] ||
                datas?.text?.[idx] ||
                datas?.fontSize?.[idx]) && (
                <Box className={classes.textFont}>
                  {datas?.fontFamily?.[idx] && <EditFontFamily type={type} />}
                  {datas?.text?.[idx] && <EditText type={type} />}
                  {datas?.fontSize?.[idx] && <EditFont type={type} />}
                </Box>
              )}
              {datas?.color?.[idx] && <EditColor type={type} />}
              {datas?.color?.[idx] && <EditTextAlign type={type} />}
            </EditLayout>
            <Divider />
          </div>
        );
      })}
    </Box>
  );
};

export default Contents;
